import React from 'react';

import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import { Tip } from '@sravni/react-icons';
import { useBoolean, useIsPhone } from '@sravni/react-utils';

import { IProductData, TYPES } from '../../types/productBlock';
import { BonusInfo } from '../BonusInfo';
import { LinkCard } from '../LinkCard';

import styles from './BannerCard.module.scss';

export const BannerCard = () => {
  const isPhone = useIsPhone();
  const [visible, setVisible] = useBoolean(false);

  const handleIconClick = React.useCallback(
    (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setVisible.on();
    },
    [setVisible],
  );

  const item: IProductData = React.useMemo(
    () => ({
      key: TYPES.BANNER,
      customStyle: {},
      title: (
        <Space direction={isPhone ? 'row' : 'column'}>
          <Heading level={isPhone ? 4 : 5} className={styles.text}>
            Получите
          </Heading>
          <Space size={4} align="center">
            <Heading level={isPhone ? 4 : 5} className={styles.text}>
              {isPhone ? ' ' : ''}500&nbsp;₽
            </Heading>
            <Icon size={16} className={styles.icon} onClick={handleIconClick}>
              <Tip />
            </Icon>
          </Space>
        </Space>
      ),
      subtitle: (
        <Text className={styles.subtitle}>За первый займ в&nbsp;приложении {isPhone ? <br /> : null}Сравни</Text>
      ),
      eventCategory: 'BANNER',
      eventAction: 'Переход из плиток',
      pageUrl: 'https://sravni.go2cloud.org/aff_c?offer_id=2443&aff_id=2&url_id=13582',
      picture: [
        <source
          key={`source-product-${TYPES.BANNER}-webp`}
          srcSet={require('./img.png')}
          media={`(min-width: ${styles.breakpointTablet})`}
          type="image/webp"
          className={styles.img}
        />,
        <img key={`img-product-${TYPES.BANNER}`} srcSet={require('./img_mob.png')} alt="banner" />,
      ],
    }),
    [isPhone, handleIconClick],
  );

  return (
    <>
      <LinkCard item={item} className={styles.banner} cardClassName={styles.card} target="_blank" />
      <BonusInfo visible={visible} onClose={setVisible.off} />
    </>
  );
};
